/* theme.js — Hookella Shopify theme: AJAX cart drawer, product page (gallery, zoom, variants, sticky bar),
 * "how to order" step sequence, yarn thread drawing. Re-initialises sections reloaded in the theme editor. */
(function () {
  "use strict";
  var doc = document, T = window.theme || {}, S = T.strings || {}, R = T.routes || {};
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var ICON = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    yarn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M6 7c4 1 8 5 9 12M9 4.6c3 2 5 6 5 9M4.5 11c3 0 7 2 9 7"/></svg>'
  };

  /* ---------- money (uses the store's money format) ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || "${{amount}}";
    function f(n, d, ts, ds) { var p = (n / 100).toFixed(d).split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p[0] + (p[1] ? ds + p[1] : ""); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === "amount_no_decimals") return f(cents, 0, ",", ".");
      if (k === "amount_with_comma_separator") return f(cents, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return f(cents, 0, ".", ",");
      if (k === "amount_with_space_separator") return f(cents, 2, " ", ",");
      return f(cents, 2, ",", ".");
    }).replace(/<[^>]+>/g, "");
  }

  /* =================== CART =================== */
  function api(url, body) {
    return fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function img(url, w) { if (!url) return ""; return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 160); }
  var inCart = {};
  function renderCart(c, bump) {
    inCart = {}; c.items.forEach(function (it) { inCart[it.variant_id] = true; });
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = c.item_count; el.hidden = !c.item_count;
      if (bump) { el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump"); }
    });
    $$("[data-cart-total]").forEach(function (el) { el.textContent = money(c.total_price); });
    $$("[data-cart-hide-empty]").forEach(function (el) { el.hidden = !c.item_count; });
    $$("[data-cart-show-empty]").forEach(function (el) { el.hidden = !!c.item_count; });
    $$("[data-cart-items]").forEach(function (box) {
      box.innerHTML = c.items.length ? c.items.map(function (it) {
        var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : "";
        return '<div class="ci"><a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="" width="70" height="84" loading="lazy"></a><div><b>' + esc(it.product_title) + "</b><small>" + esc(vt) +
          money(it.final_line_price) + (it.quantity > 1 ? " · ×" + it.quantity : "") + '</small></div><button class="rm" type="button" data-qty-key="' + esc(it.key) + '" data-q="0" aria-label="' + esc(S.remove) + '">' + ICON.trash + "</button></div>";
      }).join("") : '<div class="empty">' + ICON.yarn + "<p>" + esc(S.empty) + "</p></div>";
    });
    markAdded();
  }
  function markAdded() {
    $$(".add-mini[data-add]").forEach(function (b) { b.classList.toggle("done", !!inCart[b.getAttribute("data-add")]); });
  }
  function refreshCart(bump) { return api(R.cartJs).then(function (c) { renderCart(c, bump); return c; }); }
  function setOpen(open) {
    doc.body.classList.toggle("cart-open", open);
    var d = $("[data-cart-drawer]");
    if (d) { d.setAttribute("aria-hidden", open ? "false" : "true"); if (open) setTimeout(function () { var c = $("[data-cart-close].icon-btn", d); if (c) c.focus(); }, 60); }
  }
  function fly(from) {
    var target = $$("[data-cart-open]").filter(function (b) { return b.offsetParent; })[0];
    if (!from || !target || reduce) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect(); if (!a.width) return;
    var g = from.cloneNode(); g.removeAttribute("srcset"); g.removeAttribute("sizes"); g.className = "";
    g.style.cssText = "position:fixed;z-index:999;pointer-events:none;border-radius:18px;object-fit:cover;left:" + a.left + "px;top:" + a.top + "px;width:" + a.width + "px;height:" + a.height + "px;transition:transform .85s cubic-bezier(.5,-0.25,.3,1),opacity .85s,border-radius .85s";
    doc.body.appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      g.style.transform = "translate(" + (b.left + b.width / 2 - a.left - a.width / 2) + "px," + (b.top + b.height / 2 - a.top - a.height / 2) + "px) scale(.08)";
      g.style.opacity = ".5"; g.style.borderRadius = "50%";
    }); });
    setTimeout(function () { g.remove(); }, 900);
  }
  var toastEl, toastT;
  function toast(html) {
    if (!toastEl) { toastEl = doc.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); doc.body.appendChild(toastEl); }
    toastEl.innerHTML = html; requestAnimationFrame(function () { toastEl.classList.add("show"); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("show"); }, 2800);
  }
  function addToCart(id, qty, srcImg, then) {
    return api(R.cartAdd, { items: [{ id: +id, quantity: qty || 1 }] }).then(function (res) {
      var item = res.items ? res.items[0] : res;
      if (then === "checkout") { location.href = "/checkout"; return; }
      fly(srcImg); toast(ICON.check + "<span>" + esc(item.product_title) + " " + esc(S.added) + "</span>"); refreshCart(true);
      if (window.fbq) fbq("track", "AddToCart", { content_ids: [String(id)], content_type: "product" });
    }).catch(function (e) { toast("<span>" + esc((e && (e.description || e.message)) || S.unavailable) + "</span>"); });
  }

  doc.addEventListener("click", function (e) {
    var t = e.target.closest("[data-add],[data-qty-key],[data-cart-open],[data-cart-close]"); if (!t) return;
    if (t.hasAttribute("data-add")) {
      e.preventDefault(); if (t.disabled) return;
      var pc = t.closest(".pc");
      addToCart(t.getAttribute("data-add"), 1, pc && $(".media img:not(.alt)", pc));
    } else if (t.hasAttribute("data-qty-key")) {
      api(R.cartChange, { id: t.getAttribute("data-qty-key"), quantity: Math.max(0, +t.getAttribute("data-q")) }).then(function (c) {
        renderCart(c, true);
        if (doc.body.classList.contains("template-cart")) location.reload();
      });
    } else if (t.hasAttribute("data-cart-open")) {
      if (doc.body.classList.contains("template-cart")) return;
      e.preventDefault(); setOpen(true); refreshCart(false);
    } else { setOpen(false); }
  });
  addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
  // "Share buttons" block: copy the product link
  doc.addEventListener("click", function (e) {
    var b = e.target.closest("[data-copy-link]"); if (!b) return;
    var url = b.getAttribute("data-copy-link"), done = function () { toast(ICON.check + "<span>" + esc(b.getAttribute("data-copied") || "Link copied!") + "</span>"); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { prompt("", url); }); else prompt("", url);
  });

  // product form: AJAX add; "Buy it now" goes straight to checkout
  doc.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches("form[data-product-form]")) return;
    e.preventDefault();
    var sub = e.submitter, id = f.elements.id.value, q = +(f.elements.quantity || { value: 1 }).value || 1;
    if (sub && sub.disabled) return;
    addToCart(id, q, $(".gallery .main img:last-of-type"), sub && sub.hasAttribute("data-buy-now") ? "checkout" : null);
  });
  refreshCart(false).catch(function () {});

  /* =================== COMPONENTS (re-run per section in the editor) =================== */
  function initProduct(root) {
    $$("[data-pp]", root).forEach(function (pp) {
      if (pp._init) return; pp._init = true;
      var P; try { P = JSON.parse($("script[data-product-json]", pp).textContent); } catch (e) { return; }
      var form = $("form[data-product-form]", pp), idIn = form && form.elements.id;
      var main = $(".gallery .main", pp), thumbs = $(".thumbs", pp);
      var cur = P.variants.filter(function (v) { return v.id === +(idIn && idIn.value); })[0] || P.variants[0];
      var sel = cur.options.slice();
      function norm(u) { return String(u || "").replace(/^https?:/, "").split("?")[0]; }
      function show(src) {
        if (!src || !main) return;
        var im = $("img", main); if (!im) return;
        if (norm(im.currentSrc || im.src) === norm(src)) return;
        im.classList.add("fade");
        setTimeout(function () { im.removeAttribute("srcset"); im.removeAttribute("sizes"); im.src = src.indexOf("width=") > -1 ? src : img(src, 1200); im.onload = function () { im.classList.remove("fade"); }; }, 200);
        $$("button", thumbs).forEach(function (b) { b.setAttribute("aria-current", norm(b.getAttribute("data-src")) === norm(src) ? "true" : "false"); });
      }
      if (thumbs) thumbs.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) show(b.getAttribute("data-src")); });
      if (main && matchMedia("(hover: hover)").matches) {
        main.addEventListener("pointermove", function (e) { var r = main.getBoundingClientRect(); main.style.setProperty("--zx", (e.clientX - r.left) / r.width * 100 + "%"); main.style.setProperty("--zy", (e.clientY - r.top) / r.height * 100 + "%"); });
        main.addEventListener("pointerenter", function () { main.classList.add("zoom"); });
        main.addEventListener("pointerleave", function () { main.classList.remove("zoom"); });
      }
      function find() { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }
      function sync() {
        var v = find();
        $$("[data-opt]", pp).forEach(function (b) { b.setAttribute("aria-checked", b.getAttribute("data-value") === sel[+b.getAttribute("data-opt")] ? "true" : "false"); });
        $$("[data-buy]").forEach(function (b) {
          b.disabled = !v || !v.available;
          var span = b.hasAttribute("data-label-add") && $("span", b);
          if (span) span.textContent = !v ? S.unavailable : v.available ? b.getAttribute("data-label-add") : S.soldOut;
        });
        if (!v) return;
        cur = v; if (idIn) idIn.value = v.id;
        $$("[data-price]").forEach(function (el) { el.textContent = money(v.price); });
        $$("[data-compare]", pp).forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ""; el.hidden = !(v.compare_at_price > v.price); });
        if (v.featured_image) show(v.featured_image.src);
        if (history.replaceState) history.replaceState(null, "", location.pathname + "?variant=" + v.id);
      }
      pp.addEventListener("click", function (e) {
        var b = e.target.closest("[data-opt]");
        if (b) { sel[+b.getAttribute("data-opt")] = b.getAttribute("data-value"); sync(); }
      });
      // sticky bar appears once the buy buttons scroll out of view
      var sb = $("[data-sticky-buy]"), buy = $("#pp-buy", pp);
      if (sb && buy && "IntersectionObserver" in window) new IntersectionObserver(function (es) { sb.classList.toggle("show", !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(buy);
      if (window.fbq) fbq("track", "ViewContent", { content_ids: [String(P.id)], content_type: "product" });
    });
  }

  function initSteps(root) {
    $$("[data-steps]", root).forEach(function (wrap) {
      if (wrap._init) return; wrap._init = true;
      var steps = $$(".step", wrap), line = $(".steps-line", wrap), k = 0, timer;
      if (!steps.length) return;
      var go = function () {
        steps.forEach(function (s, i) { s.classList.toggle("on", i === k); });
        if (line) line.style.setProperty("--sp", ((k + 1) / steps.length).toFixed(3));
        k = (k + 1) % steps.length;
      };
      if (!("IntersectionObserver" in window) || reduce) { go(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { clearInterval(timer); if (e.isIntersecting && doc.body.contains(wrap)) { go(); timer = setInterval(go, 1800); } });
      }, { threshold: .3 }).observe(wrap);
    });
  }

  function initThreads(root) {
    $$(".thread", root).forEach(function (svg) {
      if (svg._init) return; svg._init = true;
      $$("path", svg).forEach(function (p) { try { p.style.setProperty("--len", Math.ceil(p.getTotalLength()) + 1); } catch (e) {} });
      if ("IntersectionObserver" in window) new IntersectionObserver(function (es, io) { if (es[0].isIntersecting) { svg.classList.add("draw"); io.disconnect(); } }).observe(svg);
      else svg.classList.add("draw");
    });
  }

  function initCollection(root) {
    $$("select[data-sort-by]", root).forEach(function (s) {
      if (s._init) return; s._init = true;
      s.addEventListener("change", function () { var u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u.toString(); });
    });
  }

  function init(root) { initProduct(root); initSteps(root); initThreads(root); initCollection(root); markAdded(); }
  init(doc);

  /* theme editor: sections are re-rendered without a page load */
  doc.addEventListener("shopify:section:load", function (e) {
    var s = e.target;
    // inline scripts (e.g. the "Frequently bought together" snippet) don't run when the editor re-renders a section
    $$("script:not([type]), script[type='text/javascript']", s).forEach(function (old) {
      var n = doc.createElement("script"); n.textContent = old.textContent; old.parentNode.replaceChild(n, old);
    });
    $$("[data-reveal]", s).forEach(function (el) { el.classList.add("in"); });
    $$("[data-split]", s).forEach(function (el) { el.classList.add("in"); });
    $$("[data-bar]", s).forEach(function (el) { el.style.setProperty("--w", el.getAttribute("data-bar") + "%"); });
    init(s);
  });
  doc.addEventListener("shopify:block:select", function (e) { var d = e.target.closest("details"); if (d) d.open = true; });
  window.HookellaTheme = { money: money, refreshCart: refreshCart, openCart: setOpen, addToCart: addToCart };
})();
